import { tns } from 'tiny-slider/src/tiny-slider'
import 'tiny-slider/dist/tiny-slider.css'

document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('[class*="vjs-about-us-team-carousel-"]')
  if (carousels.length === 0) return

  carousels.forEach((carousel) => {
    tns({
      container: carousel,
      mode: 'carousel',
      items: 1,
      controls: false,
      nav: true,
      navPosition: 'bottom',
      gutter: 0,
      speed: 1000,
      autoplay: false,
      loop: false
    })
  })
})
